/**
 * Iter 206 — API de Retos Comunitarios + Ranking de Apoyo.
 * (Separado de challengesApi.js, que es el cliente de retos 1v1.)
 */
import { api } from '@/lib/api';

export const communityChallengesApi = {
  active() { return api.get('/community-challenges/active'); },
  detail(id) { return api.get(`/community-challenges/${id}`); },
  enter(id, postId) {
    return api.post(`/community-challenges/${id}/enter`, { post_id: postId });
  },
  vote(id, entryId) {
    return api.post(`/community-challenges/${id}/vote`, { entry_id: entryId });
  },
};

export const supportRankingApi = {
  get() { return api.get('/gifts/support-ranking'); },
};

export const challengesAdminApi = {
  list(status) {
    const q = status ? `?status=${status}` : '';
    return api.get(`/admin/community-challenges${q}`);
  },
  getConfig() { return api.get('/admin/community-challenges/config'); },
  patchConfig(patch) { return api.patch('/admin/community-challenges/config', patch); },
  patchChallenge(id, patch) { return api.patch(`/admin/community-challenges/${id}`, patch); },
  resolve(id, winners) { return api.post(`/admin/community-challenges/${id}/resolve`, { winners }); },
  getRankingConfig() { return api.get('/admin/support-ranking/config'); },
  patchRankingConfig(patch) { return api.patch('/admin/support-ranking/config', patch); },
  setEligibility(body) { return api.post('/admin/support-ranking/eligibility', body); },
};

export default communityChallengesApi;
